const Yup = require('yup');
const {
  INVALID_EMAIL_DEFAULT_MESSAGE,
  US_PWC_EMAIL_NOT_PERMITTED_MESSAGE,
  emailHasBlockedUsPwcDomain,
} = require('@common-packages/shared-constants');

const emailPassesUsPwcPolicy = value => !emailHasBlockedUsPwcDomain(value);

const updateUserSchema = Yup.object()
  .shape({
    roleId: Yup.string().label('Role').required(),
    firstName: Yup.string()
      .max(40, 'First Name cannot exceed 40 characters')
      .label('First name')
      .required(),
    lastName: Yup.string()
      .max(40, 'Last Name cannot exceed 40 characters')
      .label('Last name')
      .required(),
    email: Yup.string()
      .label('Email')
      .email(INVALID_EMAIL_DEFAULT_MESSAGE)
      .test('usPwcDomain', US_PWC_EMAIL_NOT_PERMITTED_MESSAGE, emailPassesUsPwcPolicy),
    activeInd: Yup.bool().required(),
  })
  .strict();

const createUserSchema = Yup.object()
  .shape({
    firstName: Yup.string()
      .max(40, 'First Name cannot exceed 40 characters')
      .label('First name')
      .required(),
    lastName: Yup.string()
      .max(40, 'Last Name cannot exceed 40 characters')
      .label('Last name')
      .required(),
    email: Yup.string()
      .label('Email')
      .required()
      .email(INVALID_EMAIL_DEFAULT_MESSAGE)
      .test('usPwcDomain', US_PWC_EMAIL_NOT_PERMITTED_MESSAGE, emailPassesUsPwcPolicy)
      .nullable(),
    activeInd: Yup.bool().required(),
    roleId: Yup.string().label('Role').required(),
  })
  .strict();

module.exports = { updateUserSchema, createUserSchema };
